import { Navigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { RouteContextParams } from 'modules/work_schedules/lib/RouteContextParams'

const RedirectToWorkScheduleSettingsPage = () => {
  const { navigation } = useNavigation()

  const { workSchedule } = useOutletContext<RouteContextParams>()
  const to = navigation.settings.workSchedule.id.edit.fullPath({ id: workSchedule?.id })

  return <Navigate to={to} />
}

export default RedirectToWorkScheduleSettingsPage
